import React from 'react'

import { Helmet } from 'react-helmet'

import './global.css'
import Wrapper from './src/components/Wrapper'

export const wrapRootElement = ({ element }) => (
  <>
    <Helmet>
      <meta
        name="google-site-verification"
        content="hFgn8qNeubmaIXpXszIuJd5z-np2VqV9bL2hMqZmpm4"
      />
    </Helmet>
    {element}
  </>
)

export const wrapPageElement = ({ element, props }) => {
  const theme = props.pageContext.customTheme
  return <Wrapper customTheme={theme}> {element}</Wrapper>
}
